var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SearchOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5439 21.5L15.5439 15.5M17.5439 10.5C17.5439 11.4193 17.3629 12.3295 17.0111 13.1788C16.6593 14.0281 16.1437 14.7997 15.4937 15.4497C14.8437 16.0998 14.072 16.6154 13.2227 16.9672C12.3735 17.3189 11.4632 17.5 10.5439 17.5C9.62469 17.5 8.71444 17.3189 7.86516 16.9672C7.01588 16.6154 6.24421 16.0998 5.5942 15.4497C4.94419 14.7997 4.42857 14.0281 4.07679 13.1788C3.72501 12.3295 3.54395 11.4193 3.54395 10.5C3.54395 8.64348 4.28144 6.86301 5.5942 5.55025C6.90695 4.2375 8.68743 3.5 10.5439 3.5C12.4005 3.5 14.1809 4.2375 15.4937 5.55025C16.8064 6.86301 17.5439 8.64348 17.5439 10.5Z",
    stroke: "#1C1D1F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutline);
export default __webpack_public_path__ + "static/media/SearchOutline.a683966c3458a7c900da0c16efd72bd2.svg";
export { ForwardRef as ReactComponent };